import React, { useState } from "react";
import { IoSend } from "react-icons/io5";
import { motion } from "framer-motion";

export default function Input({ onSend, disabled, placeholder }) {
  const [text, setText] = useState("");

  const handleSend = (e) => {
    e.preventDefault();
    if (text.trim() && !disabled) {
      onSend(text);
      setText("");
    }
  };

  return (
    <form className="chat-input-modern" onSubmit={handleSend}>
      <input
        type="text"
        disabled={disabled}
        onChange={(e) => setText(e.target.value)}
        value={text}
        placeholder={placeholder || "Type a message..."}
        className="chat-input-core"
      />
      <motion.button
        whileHover={{ scale: 1.1, backgroundColor: "#00ced1" }}
        whileTap={{ scale: 0.9 }}
        disabled={disabled || !text.trim()}
        type="submit"
        className="chat-submit-btn"
      >
        <IoSend />
      </motion.button>

      <style>{`
        .chat-input-modern {
          display: flex;
          align-items: center;
          gap: 12px;
          background: #ffffff;
          padding: 10px 14px;
          border-radius: 18px;
          transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 1px solid rgba(0, 0, 0, 0.08);
          box-shadow: inset 0 2px 4px rgba(0,0,0,0.02);
        }
        
        .chat-input-modern:focus-within {
          background: #fff;
          border-color: #00ced1;
          box-shadow: 0 10px 25px -4px rgba(0, 206, 209, 0.15);
        }
        
        .chat-input-core {
          flex: 1;
          border: none;
          background: transparent;
          outline: none;
          font-size: 0.95rem;
          color: #1e293b;
          padding: 4px;
        }
        
        .chat-input-core::placeholder {
          color: #94a3b8;
          font-weight: 500;
        }

        .chat-submit-btn {
          background: #004080;
          color: white;
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 4px 10px rgba(0, 64, 128, 0.2);
        }
        
        .chat-submit-btn:disabled {
          background: #e2e8f0;
          color: #94a3b8;
          cursor: not-allowed;
          box-shadow: none;
        }
      `}</style>
    </form>
  );
}